
import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../fetchTools';

export const getStatsTableData = (venue_id,name,game_type_id,params) => {
  var url = `${getLocationOrigin()}/${appConfig.statsTable.data.API}/?report_id=${appConfig.statsTable.data.tables[name]}&venue_id=${venue_id}&game_type_id=${game_type_id}`;
  if (params!= undefined && "selectedDate" in params){
    url = (url + "&date=" + params["selectedDate"])
  }
  if (params!= undefined && "end_date" in params){
    url = (url + "&end_date=" + params["end_date"])
  }
  const options = {...defaultOptions};
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};




// WEBPACK FOOTER //
// ./src/app/services/API/statsTable.js